import { Route } from '@angular/router';
import { GameMode } from '@dc-core/dc-backend/dc-enums';
import { gamesLocalLeaveBusterGuard } from 'src/app/modules/games/guards/games-local-leave-buster.guard';

import { GameModeThemeRouteData } from '../../themes/game-mode.theme';

export const killerLocalGameRoutes: Route[] = [
    {
        path: 'local-games/killer',
        data: { gameModeTheme: 'killer' } satisfies GameModeThemeRouteData,
        loadComponent: () =>
            import('./pages/killer-new-game/killer-new-game.component').then((c) => c.KillerNewGameComponent),
    },
    {
        path: 'game/killer',
        data: {
            gameMode: 'killer' as GameMode,
            gameModeTheme: 'killer',
        } satisfies GameModeThemeRouteData,
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/killer-local-game-app/killer-local-game-app.component').then(
                (c) => c.KillerLocalGameAppComponent
            ),
    },
];

export const killerVenueLocalGameRoutes: Route[] = [
    {
        path: 'local-games/killer',
        data: { gameModeTheme: 'killer' } satisfies GameModeThemeRouteData,
        loadComponent: () =>
            import('./pages/killer-new-game/killer-new-game.component').then((c) => c.KillerNewGameComponent),
    },
    {
        path: 'game/killer',
        data: {
            gameMode: 'killer' as GameMode,
            gameModeTheme: 'killer',
        } satisfies GameModeThemeRouteData,
        canDeactivate: [gamesLocalLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/killer-local-game-app/killer-local-game-app.component').then(
                (c) => c.KillerLocalGameAppComponent
            ),
    },
];
